import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useToast } from "../contexts/ToastContext";

const LoginPage = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const { addToast } = useToast();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});

  const validate = () => {
    const nextErrors = {};
    if (!email || !email.includes("@")) nextErrors.email = "Введите корректную эл. почту.";
    if (!password || password.length < 7) nextErrors.password = "Минимум 7 символов.";
    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!validate()) return;

    const result = login(email, password);
    if (result.ok) {
      addToast("Вы вошли в систему.", "success");
      navigate("/");
      return;
    }

    if (result.error === "wrong_credentials") {
      addToast("Неверные учетные данные.", "error");
    } else {
      addToast("Не удалось войти. Проверьте данные.", "error");
    }
  };

  return (
    <div className="min-h-screen bg-slate-100 text-slate-900 dark:bg-slate-950 dark:text-slate-100">
      <div className="mx-auto flex min-h-screen max-w-6xl items-center justify-center px-6 py-16">
        <div className="w-full max-w-md rounded-lg border border-slate-200 bg-white p-8 shadow-lg dark:border-slate-800 dark:bg-slate-900">
          <div className="flex items-center gap-3">
            <img src="/logo.png" alt="Kia лиды" className="h-10 w-auto" />
            <div>
              <h1 className="text-xl font-semibold">Вход в Kia лиды</h1>
              <p className="text-sm text-slate-500 dark:text-slate-400">
                Панель аналитики лидов и диалогов
              </p>
            </div>
          </div>

          <form className="mt-6 space-y-4" onSubmit={handleSubmit}>
            <div>
              <label className="text-xs font-semibold uppercase text-slate-500 dark:text-slate-400">
                Эл. почта
              </label>
              <input
                type="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                placeholder="name@company.com"
                className="mt-2 w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm outline-none focus:border-slate-500 focus:ring-2 focus:ring-slate-900/10 dark:border-slate-700 dark:bg-slate-950"
              />
              {errors.email && (
                <p className="mt-1 text-xs text-rose-600 dark:text-rose-300">{errors.email}</p>
              )}
            </div>

            <div>
              <label className="text-xs font-semibold uppercase text-slate-500 dark:text-slate-400">
                Пароль
              </label>
              <input
                type="password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                placeholder="Минимум 7 символов"
                className="mt-2 w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm outline-none focus:border-slate-500 focus:ring-2 focus:ring-slate-900/10 dark:border-slate-700 dark:bg-slate-950"
              />
              {errors.password && (
                <p className="mt-1 text-xs text-rose-600 dark:text-rose-300">{errors.password}</p>
              )}
            </div>

            <button
              type="submit"
              className="h-10 w-full rounded-lg bg-slate-950 px-4 text-sm font-semibold text-white hover:bg-slate-800 focus:outline-none focus:ring-2 focus:ring-slate-900/20 dark:bg-slate-100 dark:text-slate-950 dark:hover:bg-white"
            >
              Войти
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
